/** The address parameter that holds the row the drawer shows: `?row=77`. */
export const ROW_DRAWER_PARAM = 'row';

/** The Excel row the address opens in the drawer; `null` when it names none (or not a row number). */
export const readDrawerRow = (params: URLSearchParams): number | null => {
    const value = params.get(ROW_DRAWER_PARAM);
    if (value === null || !/^\d+$/.test(value)) {
        return null;
    }
    const rowNumber = Number(value);
    return rowNumber >= 1 ? rowNumber : null;
};

/**
 * The address with the drawer on `rowNumber`, or closed (`null`), every other
 * parameter kept: closing the drawer returns to the same tab.
 */
export const writeDrawerRow = (
    params: URLSearchParams,
    rowNumber: number | null,
): URLSearchParams => {
    const next = new URLSearchParams(params);
    if (rowNumber === null) {
        next.delete(ROW_DRAWER_PARAM);
    } else {
        next.set(ROW_DRAWER_PARAM, String(rowNumber));
    }
    return next;
};
